import { render } from "./LiveLabel.vue?vue&type=template&id=2930f561&ts=true"
import script from "./LiveLabel.vue?vue&type=script&lang=ts"
export * from "./LiveLabel.vue?vue&type=script&lang=ts"

import "./LiveLabel.vue?vue&type=style&index=0&id=2930f561&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__